import React, { useState, useEffect } from 'react';
import { Shield } from '@mui/icons-material';
import Header from '../../../shared/components/layout/Header';
import Footer from '../../../shared/components/layout/Footer';
import { Alert } from '../../../shared/components';
import { useRoles } from '../hooks/useRoles';
import TablaRoles from './TablaRoles';
import TablaMenus from './TablaMenus';
import './GrillaRoles.css';

const GrillaRoles = () => {
  const { roles, estadosTurno, menus, loading, error, cargarRoles, setError } = useRoles();
  const [tabActivo, setTabActivo] = useState('estados');

  useEffect(() => {
    cargarRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grilla-roles">
      <Header />
      <div className="main-content">
        <div className="page-header">
          <h2 className="page-title-grilla">
            <Shield sx={{ fontSize: 32, mr: 1, verticalAlign: 'middle', color: '#6d1212' }} />
            Gestión de Roles
          </h2>
          <span className="page-subtitle">Configuración de permisos por rol</span>
        </div>

        <Alert message={error} onClose={() => setError('')} />

        <div className="tabs-container">
          <button 
            className={`tab-button ${tabActivo === 'estados' ? 'active' : ''}`}
            onClick={() => setTabActivo('estados')}
          >
            Estados de Turno
          </button>
          <button 
            className={`tab-button ${tabActivo === 'menus' ? 'active' : ''}`}
            onClick={() => setTabActivo('menus')}
          >
            Menús
          </button>
        </div>

        {tabActivo === 'estados' ? (
          <TablaRoles
            roles={roles}
            estadosTurno={estadosTurno}
            loading={loading}
          />
        ) : (
          <TablaMenus
            roles={roles}
            menus={menus}
            loading={loading}
          />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default GrillaRoles;
